













































































































































































































import draggable from "vuedraggable";
import Vue from "vue";
import { default as moment } from "moment-timezone";
import { timer } from "rxjs";
import { take, takeWhile } from "rxjs/operators";

import { MonatsabschlussZeile } from "@/api/Abrechnung";
import { Dame, MONATSNAMEN, sortDamenAlnum, TIMEZONE, WOCHENTAGE } from "@/api/Termine";
import { default as MonatsabschlussEditContextMenu, MenuItemSelected, PopoverMode } from "./MonatsabschlussEditContextMenu.vue";
import { default as MonatsabschlussEditPopover, MonatsabschlussUpdateEvent } from "./MonatsabschlussEditPopover.vue";

declare interface Tagesabschluss {
  dame: number;
  miete: number;
  steuer: number;
  kreuz: boolean;
}

declare interface DameSumme {
  dame: number;
  miete: number;
  kreuze: number;
}
declare interface TableRow {
  kalendertag: string;
  tag: string;
  damen: DameSumme[];
  summe: DameSumme;
}

declare interface TableRowGroup{
  tage: TableRow[];
  summe: DameSumme[];
  subtotal: DameSumme;
}
declare type TableRowGroups = TableRowGroup[];

declare type SummenZeile = DameSumme[];

declare type DayBuffer = { [tag: string]: DameSumme };

function getTableRowTag(tempTag: HTMLElement | null): HTMLElement | null {
  for (let i = 0; tempTag && i < 5; i++) {
    if (tempTag.tagName.toUpperCase() == "TR") { return tempTag; }
    tempTag = tempTag.parentElement;
  }
  return null;
}

function hashCode(s: string) {
  let h = 0,
    i = s.length - 1;
  while (i >= 0) {
    h = ((h << 5) - h + s.charCodeAt(--i)) | 0;
  }
  return h;
}

export default Vue.extend({
  name: "MonatsabschlussEdit",
  components: {
    draggable,
    MonatsabschlussEditContextMenu,
    MonatsabschlussEditPopover,
  },
  directives: {
    //"draggable-container": DraggableContainer,
    //"draggable-row": DraggableRow,
  },
  props: {
    studio: {
      type: Object,
      validator: (studio: any) =>
        studio == null || (studio.id && studio.bezeichner),
    },
    monat: { type: Number, required: true },
    jahr: { type: Number, required: true },
  },
  data() {
    return {
      calendarDayGroups: [] as TableRowGroups,
      summe: [] as SummenZeile,
      total: {} as DameSumme,
      damenImMonat: [] as Dame[],
      dragSourceTag: "0",
      lastEvent: "",
      selectedDays: {} as DayBuffer,
      monatZurueckDisabled: false,
      monatVorDisabled: false,
      tageZusammenfuehrenDialogSichtbar: false,
    };
  },
  mounted(): void {
    this.updateAllData();
  },
  computed: {
    ueberschrift(): string {
      return `Monatsabschluss für ${this.monatLesbar} in ${this.studio?.name}`;
    },
    monatLesbar(): string {
      if (this.monat >= 0 && this.monat <= 12) {
        return `${MONATSNAMEN[this.monat]} / ${this.jahr}`;
      } else {
        return "<unbestimmt>";
      }
    },
  },
  watch: {
    dameIndex(newDameIndex: number): void {
      this.updateAllData();
    },
  },
  methods: {
    format(betrag: number, printZeros = false): string {
      if (betrag == undefined) {
        return "???";
      }
      return betrag > 0 || printZeros
        ? betrag.toLocaleString("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
        : "";
    },
    setMonat(offset: number): void {
      /*
      const neueDameIndex = this.dameIndex + offset;
      this.monatZurueckDisabled = neueDameIndex <= 0;
      this.monatVorDisabled = neueDameIndex >= this.damenDesMonats.length - 1;
      if (neueDameIndex < 0 && neueDameIndex >= this.damenDesMonats.length) {
        this.$toast.add({
          severity: "error",
          summary: "Auswahl ungültig",
          detail: "Die gewählte Dame ist nicht verfügbar",
          life: 3000,
        });
        return;
      }

      this.$emit("dameSelected", neueDameIndex);
      */
    },
    onDragEvent(event: any, dame: number) {
      const tag = (getTableRowTag(event.to) as any).dataset.kalendertag;
      console.log(event.type, dame, tag, event);
      if (event.type == "start") {
        this.dragSourceTag = tag;
        this.selectedDays[`${tag}`] = this.calendarDayGroups.flatMap(group => group.tage).filter(s => s.kalendertag == tag)[0].damen.filter(zelle => zelle.dame == dame)[0];
      }
      if (event.type == "end") {
        this.tageseinnahmenVerschieben(
          dame,
          this.dragSourceTag,
          tag
        ).then(() => {
          this.selectedDays = {};
        });
      }
    },
    cloneCell(p1: any, p2?: any, p3?: any) {
      console.log("CloneCell called", p1, p2, p3);
      return p1;
    },
    getRowCssClass(tag: TableRow) {
      return this.isDaySelected(tag.tag) ? "highlight" : "";
    },
    getCssClass(betrag: number) {
      return betrag ? "spalte-betrag hat-preise" : "spalte-betrag";
    },
    formatDatum(tag: string): string {
      return `${tag}.${(this.monat < 9 ? "0" : "") + (this.monat + 1)}.${
        this.jahr
      }`;
    },
    isDaySelected(tag: string): boolean {
      return !!this.selectedDays[tag];
    },
    formatTag(tag: number): string {
      return ((tag < 10) ? "0" : "") + tag;
    },
    clearDataTable(): void {
      this.calendarDayGroups = [];
      const monat = moment().tz(TIMEZONE).year(this.jahr).month(this.monat).date(1).hour(12);
      const maxDay = monat.daysInMonth();

      const allMonthDays: TableRow[] = [];
      for (let tag = 1; tag <= maxDay; tag++) {
        const formattedKalendertag = this.formatTag(tag);
        const tagAsFormattedString = WOCHENTAGE[monat.date(tag).isoWeekday()-1] + ", " + formattedKalendertag + ".";
        allMonthDays.push({
          kalendertag: formattedKalendertag,
          tag: tagAsFormattedString,
          damen: [],
          summe: {
            dame: -1,
            miete: 0,
            kreuze: 0,
          },
        } as TableRow);
      }
      while (allMonthDays.length > 0) {
        const groups = this.calendarDayGroups;
        if (!groups) {
          console.log("calendarGroups undefiniert!");
          break;
        }
        groups.push({
          tage: allMonthDays.splice(0, Math.min(7, allMonthDays.length)),
          summe: [],
          subtotal: {dame:-1, miete: 0, kreuze: 0,},
        });
      }
    },
    async tageseinnahmenVerschieben(dame: number, vonTag: string, nachTag: string) {
      const vonTagAsNumber = parseInt(vonTag);
      const nachTagAsNumber = parseInt(nachTag);
      if (
        vonTagAsNumber <= 0 ||
        vonTagAsNumber >= 32 ||
        nachTagAsNumber <= 0 ||
        nachTagAsNumber >= 32 ||
        vonTagAsNumber == nachTagAsNumber
      ) {
        console.log("Keine gültigen Tage ausgewählt; nix wird verschoben.");
        this.$toast.add({
              severity: "error",
              summary: "Zusammenführen",
              detail: `Test: Tage sind nicht verschieden.`,
              life: 3000,
            });
        return;
      } else {
        //this.dragSourceTag = this.dragTargetTag = 0;
      }
      console.log(`Verschiebe ${vonTag} auf ${nachTag}...`);
      const dameObj = this.damenImMonat.filter(d => d.id == dame)[0];
      /*
      let name = dameObj.kuenstlername;
      if (name.endsWith('s') || name.endsWith('x')) { name += "'"; } else { name += "s"; }
      this.$toast.add({
              severity: "warn",
              summary: "Zusammenführen",
              detail: `Test: Verschieben von ${name} Diensten vom ${vonTagAsNumber} auf den ${nachTagAsNumber}.`,
              life: 3000,
            });
            */
      const sourceTag = this.getTageszeile(vonTag);
      const targetTag = this.getTageszeile(nachTag);
      const monat = moment(new Date(this.jahr, this.monat));

      this.$store.dispatch("appLoading", true);
      this.$znaApi
        .buchungstagVerschieben(
          this.studio,
          monat,
          dameObj,
          vonTag,
          nachTag,
          true
        )
        .subscribe(
          (monatsdaten: MonatsabschlussZeile[] | string) => {
            if (Array.isArray(monatsdaten)) {
              this.neueMonatsdaten(monatsdaten);
            }
            this.$store.dispatch("appLoading", false);
          },
          _ => {
            this.$store.dispatch("appLoading", false);
          });
    },
    updateAllData(): void {
      /*
      if (this.dameIndex < 0 || this.dameIndex >= this.damenDesMonats.length) {
        this.clearDataTable();
        return;
      }
      */
      this.retrieveData();
    },
    retrieveData(): void {
      /*
      if (this.dameIndex >= this.damenDesMonats.length) {
        console.log(
          "Datenaktualisierung verhindert, da keine gültige Dame ausgewählt wurde"
        );
        return;
      }
      */

      this.$store.dispatch("appLoading", true);

      const monat = moment(new Date(this.jahr, this.monat));
      this.$znaApi
        .getTermineMonat(this.studio, monat, true)
        .subscribe(
          (monatsdaten) => {
            timer(200)
              .pipe(
                takeWhile(
                  (value, index) => this.calendarDayGroups == undefined
                ),
                take(100)
              )
              .subscribe(
                () => {
                  // Hier wird nur gepollt
                },
                () => {
                  // Kann bei `timer` nicht auftreten
                  this.$store.dispatch("appLoading", false);
                },
                () => {
                  // calendarGroups ist/sind nun definiert
                  this.neueMonatsdaten(monatsdaten);

                  this.$store.dispatch("appLoading", false);
                }
              );
          },
          (error: any) => {
            this.$toast.add({
              severity: "error",
              summary: "Laden der Daten fehlgeschlagen",
              detail: error,
              life: 3000,
            });
            this.$store.dispatch("appLoading", false);
          }
        );
    },
    neueMonatsdaten(monatsdaten: MonatsabschlussZeile[]): void {
      this.clearDataTable();
      const calendarDayGroups = this.calendarDayGroups;
      this.damenImMonat = monatsdaten
        .map(zeile => zeile.dame as Dame)
        .sort(sortDamenAlnum);
      const mapDamenToCells = () => this.damenImMonat.map(d => ({
          dame: d.id,
          miete: 0,
          kreuze: 0,
        } as DameSumme));
      this.calendarDayGroups.forEach(group => {
        group.tage.forEach(tableRow => {
          tableRow.damen = mapDamenToCells();
        });
        group.summe = mapDamenToCells();
      });
      this.summe = mapDamenToCells();
      this.total = {dame: -1, miete: 0, kreuze: 0,} as DameSumme;

      monatsdaten
        .map(md => {
          const dame = md.dame as Dame;
          md.tage?.forEach(abrechnungTag => {
            const buchungstag = this.getTageszeile(abrechnungTag.buchungstag);
            const dameOffset = buchungstag.damen.findIndex(zelle => zelle.dame == dame.id);
            const zelle = buchungstag.damen[dameOffset];
            const wochengruppe = this.getWochengruppe(abrechnungTag.tag);
            const summenzelle = wochengruppe.summe[dameOffset];
            const tagesKreuzBereitsErfasst = zelle.kreuze > 0;
            const zuAktualisierendeMietpreisZellen = [zelle, buchungstag.summe, summenzelle, wochengruppe.subtotal, this.summe[dameOffset], this.total];
            const kreuze = md.steuer > 0 && !tagesKreuzBereitsErfasst ? 1 : 0;
            [zelle, buchungstag.summe, summenzelle, wochengruppe.subtotal, this.summe[dameOffset], this.total].forEach(zelle => {
              zelle.miete += abrechnungTag.miete;
              zelle.kreuze += kreuze;
            });
          });
        });

      this.updateSummen();
    },
    getWochengruppe(tag: string): TableRowGroup {
      const buchungstag = parseInt(tag);
      const wochengruppenIndex = Math.floor((buchungstag - 1) / 7);
      return this.calendarDayGroups[ wochengruppenIndex ];
    },
    getTageszeile(tag: string): TableRow {
      const buchungstag = parseInt(tag);
      const selectedDay = this.getWochengruppe(tag).tage[ Math.floor((buchungstag - 1) % 7) ];
      return selectedDay;
    },
    updateSummen(): void {
      /*
      const gesamtsumme: DameSumme = { renderKey: 'summe', summe: 0, summeDdSteuer: 0, anzahlTage: 0 };
      this.calendarDayGroups.forEach((calendarDayGroup: CalendarDayGroup) => {
        calendarDayGroup.anzahlTage = 0;
        calendarDayGroup.days.forEach((day) => {
          calendarDayGroup.summe += day.miete;
          calendarDayGroup.summeDdSteuer += day.steuer;
          if (day.tag == day.buchungstag) {
            calendarDayGroup.anzahlTage++;
          }
        });
        gesamtsumme.summe += calendarDayGroup.summe;
        gesamtsumme.summeDdSteuer += calendarDayGroup.summeDdSteuer;
        gesamtsumme.anzahlTage += calendarDayGroup.anzahlTage;
      });
      const summe: Summe = this.summe;
      summe.summe = gesamtsumme.summe;
      summe.summeDdSteuer = gesamtsumme.summeDdSteuer;
      */
    },
    monatsabschlussNeuBerechnen() {
      const monat = moment(new Date(this.jahr, this.monat, 1, 12));
      this.$store.dispatch("appLoading", true);
      this.$znaApi.monatsabschlussNeuBerechnen(this.studio, monat, true, undefined)
        .subscribe(monatsdaten => {
            this.neueMonatsdaten(monatsdaten);
            this.$store.dispatch("appLoading", false);
        });
    },
    openContextMenu(kalendertag: string, summe: DameSumme) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (kalendertag && summe) {
          const contextMenu = this.$refs.contextMenu as any;
          console.log(kalendertag);
          console.log(summe);
          contextMenu.open(kalendertag, moment().year(this.jahr).month(this.monat).daysInMonth(), summe.dame, summe.miete);
        }
      }
    },
    editOrCreate(kalendertag: string, summe: DameSumme) {
      console.log("editOrCreate");
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (kalendertag && summe) {
          this.showDialog("edit", kalendertag, summe.dame, summe.miete);
        }
      }
    },
    onMenuItemSelected(selectionEvent: MenuItemSelected) {
      function calcNachTag(vonTag: string, deltaTag: number): string {
        const nachTagNum = parseInt(vonTag) + deltaTag;
        return ((nachTagNum < 10) ? "0" : "") + nachTagNum;
      }

      switch (selectionEvent.popoverMode) {
        case "edit":
        case "select-date":
          this.showDialog(
            selectionEvent.popoverMode,
            selectionEvent.kalendertag,
            selectionEvent.dame,
            selectionEvent.miete
          );
          break;
        case "move-previous":
          this.tageseinnahmenVerschieben(selectionEvent.dame, selectionEvent.kalendertag, calcNachTag(selectionEvent.kalendertag, -1));
          break;
        case "move-next":
          this.tageseinnahmenVerschieben(selectionEvent.dame, selectionEvent.kalendertag, calcNachTag(selectionEvent.kalendertag, 1));
          break;
      }
    },
    showDialog(popoverMode: PopoverMode, tag: string, dame: number, miete: number) {
      console.debug(event);
      const popover: any = this.$refs.popover;
      const monat = moment().tz(TIMEZONE).year(this.jahr).month(this.monat);
      this.$nextTick(() => popover.show(popoverMode, tag, monat.daysInMonth(), monat.format('.MM.YYYY'), dame, miete));
    },
    monatsabschlussUpdated(update: MonatsabschlussUpdateEvent) {
      this.$store.dispatch("appLoading", true);
      this.$znaApi.updateMonatsabschlussDame(
        this.studio,
        moment().tz(TIMEZONE).year(this.jahr).month(this.monat).date(update.tag),
        update.dame,
        update.miete
      ).subscribe(_ => {
        this.retrieveData();
      });
    },
  },
});
